export enum GuestTypeEnum {
  blocked = 'blocked',
  unknown = 'unknown',
  guest = 'guest',
  roomMate = 'roomMate',
  lead = 'lead',
  apartmentOwner = 'apartmentOwner',
}
